// cs-portal (Bulutpark Portal) adres yardimcilari.
// Adres calisma zamaninda public/config.json icindeki "csPortalUrl" alanindan okunur;
// Docker'da CS_PORTAL_URL ortam degiskeni ile (nginx/docker-entrypoint.sh) override edilebilir.
// Alan yoksa production adresi kullanilir.

import { vueProps } from '@/vue-app'

export const DEFAULT_CS_PORTAL_URL = 'https://cs-portal.bulutpark.tr'

export function csPortalUrl () {
  const configured = vueProps.$config && vueProps.$config.csPortalUrl
  const url = (configured && String(configured).trim()) || DEFAULT_CS_PORTAL_URL
  return url.replace(/\/+$/, '')
}

export function csPortalApi () {
  return csPortalUrl() + '/api'
}
